import React from "react";
import styled from "styled-components";
import SortMethodSelectBox from "../Component/SortMethodSelectBox";
import RankPointInput from "../Component/RankPointInput";

export default function WodEventPointBox(props) {
  const {
    isEdit,
    sortMethod,
    setSortMethod,
    pointGap,
    setPointGap
  } = props

  return (
    <TopLevelWrapper>
      <ColumnBox>
        <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#2F2F32' cursor='default'>이벤트 포인트</Text>
      </ColumnBox>
      <ViewBox>
        <ComponentWrapper alignItems='flex-start'>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>배점 기준</Text>
          <SelectBoxWrapper>
            <SortMethodSelectBox isEdit={isEdit} value={sortMethod} setValue={setSortMethod}/>
          </SelectBoxWrapper>
        </ComponentWrapper>
        <ComponentWrapper alignItems='flex-end'>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>순위별 포인트 간격</Text>
          <TotalPointInputWrapper>
            <PointInputWrapper>
              <RankPointInput isEdit={isEdit} value={pointGap} setValue={setPointGap} placeholder='1'/>
            </PointInputWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={12} color='#FFFFFF' cursor='default'>Point</Text>
          </TotalPointInputWrapper>
        </ComponentWrapper>
      </ViewBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const ColumnBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 5px 10px;
  
  border-radius: 5px 5px 0px 0px;
  background-color: #6DD49E;
`;

const ViewBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 15px 15px 20px 15px;

  width: calc(100% - 30px);

  border-radius: 0px 10px 10px 10px;
  background-color: #17171B;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: ${props => props.alignItems};

  width: 36%;

  gap: 8px;
`;

const SelectBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 36px;
`;

const TotalPointInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;

  gap: 5px;
`;

const PointInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: calc(100% - 36px);
  height: 36px;
`;

const Text = styled.div`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
